import PropTypes from "prop-types";
import React from "react";

class NavLoaderProxy extends React.PureComponent {
  static get propTypes() {
    return {
      children: PropTypes.string,
      setLoaderStatus: PropTypes.func.isRequired,
      setLoaderText: PropTypes.func.isRequired,
    };
  }

  static get defaultProps() {
    return {
      children: null,
    };
  }

  componentDidMount() {
    this.props.setLoaderStatus(true);
    this.props.setLoaderText(this.props.children);
  }

  componentWillUnmount() {
    this.props.setLoaderStatus(false);
    this.props.setLoaderText(null);
  }

  render() {
    return null;
  }
}

export { NavLoaderProxy };
